// По ТЗ 10.09.2026: справочник 11 служб войскового хозяйства.
// Каждой службе на UI соответствует своя страница со складом и 5 табами.
import { http } from '@/api/http'

// Порядок и коды 11 служб (совпадают с backend Service.CODE_CHOICES).
export const SERVICE_CODES = [
  'pfs', 'ovs', 'kes', 'gsm', 'svyaz', 'asu',
  'rav', 'inzh', 'abts', 'vet', 'med',
]

export async function listServices() {
  const { data } = await http.get('wms/services/')
  return Array.isArray(data) ? data : (data?.results || [])
}

export async function getServiceByCode(code) {
  const all = await listServices()
  return all.find(s => s.code === code) || null
}
